"use client";

import { CitationTool } from "@/components/citation-tool";
import { getFeaturedStyles } from "@/data/citation-styles";

/**
 * Live citation generator embedded on the Encyclopedia landing page. The tool opens
 * straight on the manual-entry tab preset to the "Encyclopedia entry" source type (CSL
 * `entry-encyclopedia`). Users type the entry title, encyclopedia name, author, and year,
 * and pick any of the 10,834 styles.
 */
export default function EncyclopediaCitationGeneratorWidget() {
  return (
    <CitationTool
      initialManualType="entry-encyclopedia"
      initialMode="manual"
      styles={getFeaturedStyles()}
    />
  );
}
